import requests from '@/script/requests'

// 接口请求封装 post提交
export function post(url, data) {
    let headers = {
        'Content-Type': 'application/json',
    };

    if (url != 'login') headers['Access-Token'] = localStorage.getItem('accessToken'); //除登录以外请求头部都携带token

    let res = requests({
        headers,
        url,
        method: 'post',
        data,
    });
    return res;
}

// get提交
export function get(url) {
    return requests({
        headers: {
            'Content-Type': 'application/json',
        },
        url,
        method: 'get',
    })
}

//download
export function download(url, params) {
    return requests({
        headers: {
            'Content-Type': 'application/json',
        },
        params,
        url,
        method: 'get',
        responseType: 'blob'
    })
}


// WEBPACK FOOTER //
// ./src/script/api.js